import { range } from 'lodash/fp';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type DateUnitDataFragment } from '../../../../api/fragments';
import { DateTimeUnit } from '../../../../api/types';
import { useThemeComponents } from '../../../../themes';

type RentalDurationProps = {
    availableNumberOfBookingRange: DateUnitDataFragment;
};

const convertAvailableNumberBookingToDays = (availableBooking: DateUnitDataFragment) => {
    if (availableBooking.unit === DateTimeUnit.Hours) {
        return Math.ceil(availableBooking.value / 24);
    }

    return availableBooking.value;
};
const RentalDuration = ({ availableNumberOfBookingRange }: RentalDurationProps) => {
    const days = convertAvailableNumberBookingToDays(availableNumberOfBookingRange);
    const { t } = useTranslation('giftVoucherJourney');
    const {
        FormFields: { SelectField, InputNumberField },
    } = useThemeComponents();

    const daysRange = useMemo(() => range(1, days + 1).map(value => ({ label: value, value })), [days]);
    const inputField = useMemo(() => {
        if (days > 0) {
            return (
                <SelectField
                    {...t('giftVoucherJourney:journey.numberOfBookingReferenceDays', { returnObjects: true })}
                    name="numberOfBookingReferenceDays"
                    options={daysRange}
                />
            );
        }

        return (
            <InputNumberField
                {...t('giftVoucherJourney:journey.numberOfBookingReferenceDays', { returnObjects: true })}
                name="numberOfBookingReferenceDays"
            />
        );
    }, [InputNumberField, SelectField, days, t]);

    return inputField;
};

export default RentalDuration;
